<template>
  <div>
    <app-header title="">
      <template v-slot:actions>
        <button
          type="button"
          class="btn btn-primary mt-2 mt-xl-0"
          v-c-modal:modal="{}"
        >
          <i class="far fa-plus"></i> Stack
        </button>
      </template>
    </app-header>

    <div class="container my-5">
      <h2>Stacks.</h2>

      <list-filters v-model="params" />

      <c-data-list ref="dataList" :items="stacks" @load="loadNextPage">
        <template v-slot:columns>
          <div class="col-12 col-lg-6 col-xl-6">
            <p>Company</p>
          </div>
          <div class="col-6 col-lg-4 col-xl-4">
            <p>Name</p>
          </div>
          <div class="col-6 col-lg-2 col-xl-2 text-end">Auto Bill</div>
        </template>
        <template v-slot:default="slotProps">
          <stacks-list-item :stack="slotProps.item" />
        </template>
      </c-data-list>
    </div>

    <stacks-modal
      ref="modal"
      @created="newStackCreated"
      title="Create Stack"
      :stack="newStack"
      mode="create"
      :client-id="clientId"
    ></stacks-modal>
  </div>
</template>

<script>
import { isEqual, debounce } from "lodash";
import { mapState, mapActions } from "vuex";
import { Selectize } from "components/form/input";
import LazyLoading from "components/misc/LazyLoading";
import LaddaButton from "components/form/input/ladda-button.vue";
import { notify } from "utils";
import StacksModal from "./StacksModal";
import FilterDraw from "./FilterDraw";
import StacksListItem from "./StacksListItem"
import ListFilters from "./ListFilters";

import StackModel from "./../../models/stack.js";

export default {
  components: {
    Selectize,
    LaddaButton,
    LazyLoading,
    StacksModal,
    FilterDraw,
    StacksListItem,
    ListFilters
  },

  data: function () {
    return {
      loading: true,
      search_string: "",
      sort: "Newest",
      searching: false,
      deleted: false,
      params: {},
      toggleFilters: {
        draft: false,
        sent: false,
        signed: false,
        archived: false,
        overdue: false,
        template: false,
      },

      newStack: new StackModel(),
      clientId: null,
      contactId: null,
    };
  },
  mounted: function () {
    this.getStacks(this.params);

    this.$watch("params", async (params, oldParams) => {
      if (isEqual(params, oldParams)) {
        return;
      }

      await this.getStacks(this.params);
    });
  },

  computed: {
    ...mapState("stack", { stacks: "list", pagination: "pagination" }),

    haveStacks() {
      if (this.stacks) {
        return this.stacks.length > 0;
      }
    },
  },

  methods: {
    ...mapActions("stack", {
      getStacks: "getList",
      getStacksForNextPage: "getListForNextPage",
    }),

    async loadNextPage(done) {
      try {
        await this.getStacksForNextPage(this.params);

        done();
      } catch (error) {
        done(true);
      }
    },

    newStackCreated() {
      this.getStacks(this.params)
    },

    clientCreated(clientId) {
      this.clientId = clientId;
    }
  },
};
</script>

<style scoped>
</style>
